import React from "react";

const ParagraphViews = (props) => {
  const { info } = props;
  return (
    <div className="components-paragraph-views">
      <div className="container" dangerouslySetInnerHTML={{ __html: info.translation?.title }}></div>
    </div>
  );
};

export default ParagraphViews;
